import { useLocaleKeys } from '~/i18n';
export const useAgreementsChipConnector = ()=>{
    const { t } = useLocaleKeys('agreement.dashboard.aiSearch');
    return {
        labels: {
            and: t.andConnector(),
            or: t.orConnector()
        },
        toggleBiName: 'agreements_ai_search_toggle_connector'
    };
};
